import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconContact: React.FC<Props> = ({ width = 20, height = 20 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7933 18.1265C13.4108 18.1265 13.0259 18.0748 12.6459 17.9707C7.50838 16.5607 3.44087 12.4957 2.03004 7.36152C1.7092 6.19402 1.88499 4.97735 2.52666 3.93735C3.17083 2.89235 4.23004 2.15485 5.43254 1.91485C6.23254 1.75485 7.02338 2.11152 7.42921 2.79569L8.7317 4.99567C9.3642 6.06401 9.04992 7.43984 8.01576 8.12818L7.07337 8.75485C7.95421 10.5632 9.43575 12.049 11.2366 12.929L11.8718 11.9815C12.5643 10.949 13.94 10.6398 15.0075 11.2757L17.2101 12.589C17.8918 12.9957 18.2442 13.7915 18.0892 14.5682C17.8492 15.7707 17.1117 16.8298 16.0675 17.474C15.3658 17.9057 14.585 18.1265 13.7933 18.1265ZM5.81503 3.12484C5.7742 3.12484 5.73255 3.12902 5.69255 3.13736C4.81422 3.31319 4.05339 3.84234 3.59172 4.59317C3.13422 5.33484 3.00837 6.20068 3.2367 7.02985C4.53087 11.7407 8.26336 15.4715 12.9767 16.7649C13.8067 16.9924 14.6699 16.8657 15.4108 16.409C16.1608 15.9465 16.6909 15.1848 16.8634 14.3215C16.9151 14.0623 16.7976 13.7965 16.5692 13.6607L14.3675 12.3473C13.8716 12.0523 13.2316 12.1965 12.91 12.6757L11.9808 14.0632C11.8141 14.3115 11.4926 14.4065 11.2209 14.2915C8.75175 13.259 6.74257 11.2457 5.70924 8.76734C5.59424 8.49067 5.69078 8.17235 5.93995 8.00651L7.32423 7.08567C7.80423 6.7665 7.95002 6.12734 7.65585 5.63151L6.35336 3.43233C6.2392 3.239 6.03253 3.12484 5.81503 3.12484Z"
      fill="#3E454D"
    />
  </svg>
);

export default IconContact;
